<template>
  <div class="search-page flex flex-col justify-between h-full p-36">
    <WFSearch
      ref="search"
      :showLogo="true"
      :showName="false"
      :showOutputField="true"
      :showKeyboard="!mobile"
      :limit="4"
      @clicked="onPOIClick"
      class="wf-component wf-search h-full text-xl flex flex-col align-center th-list"
    >
      <template v-slot="slotProps">
        <ListPOI
          :poi="slotProps.poi"
          @onPOIClick="onPOIClick(slotProps.poi)"
          class="wf-list-item"
        ></ListPOI>
      </template>
    </WFSearch>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ListPOI from "./ListPOI.vue";

export default {
  components: {
    ListPOI,
  },
  computed: {
    ...mapState("wf", ["language", "pois", "mobile"]),
  },
  data() {
    return {
      currentTab: "all",
      shortcuts: false,
      currentGroup: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
     //this.$refs.search.setOutput("search-output");
      this.$refs.search.addLayout("et", {
					'name': "Estonian",
					'local_name': "Eesti",
					'lang': "et",
					'keys': {
						"default": [
							["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"],
							["q", "w", "e", "r", "t", "y", "u", "i", "o", "p", "\u00FC", "\u00F5"],
							["a", "s", "d", "f", "g", "h", "j", "k", "l", "\u00F6", "\u00E4"],
							["z", "x", "c", "v", "b", "n", "m", {'key': "&#171;", 'action': ["backspace"], cls: "delete"}],
							[{"key": " ", "cls": "key_spacebar"}]
							]
					}});
      this.$refs.search.addLayout("en", {
        name: "English",
        keyboard: "US International",
        local_name: "English",
        lang: "en",
        keys: {
          default: [
            ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
            ["a", "s", "d", "f", "g", "h", "j", "k", "l"],
            [
              "z",
              "x",
              "c",
              "v",
              "b",
              "n",
              "m",
              ".",
              "&",
              { key: "\u00AB", action: ["backspace"] },
            ],
            [{ key: "\u02FD", cls: "key_spacebar" }],
          ],
        },
      });
    });
  },
  methods: {
    showTab(tab) {
      this.currentTab = tab;
    },
    shortcutClicked(nearest) {
      this.$emit("clicked", nearest);
    },
    onPOIClick(poi) {
      this.$emit("clicked", poi);
    },
    filterByGroup(group) {
      this.$store.dispatch("wf/SET_FILTERED_POIS", group.getPOIs());
      this.currentGroup = group;
      if (this.$refs["searchscroll"]) {
        this.$refs["searchscroll"].reset();
      }
    },
    filterAll() {
      this.$store.dispatch("wf/SET_FILTERED_POIS", this.pois);
      this.currentGroup = null;

      if (this.$refs["searchscroll"]) {
        this.$refs["searchscroll"].reset();
      }
    },
  },
};
</script>

<style lang="postcss">
.keyboard-key_spacebar {
  width: 60% !important;
}

.wf-search-results {
  padding: 1.2rem;
  padding-left: 3.2rem;
  padding-right: 3.2rem;
  min-height: 3rem;
  text-align: center;
  font-weight: 500;
  font-size: 2.4rem;
  flex-grow: 1;
}


.wf-search-results .wf-list {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  row-gap: 1.2rem;
  column-gap: 2.4rem;
}


.keyboard-key_spacebar {
  min-width: 30%;
  font-size: 400%;
  line-height: 0.7 !important;
}

.pois-content {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  overflow: hidden;
}

.poi-groups {
  padding: 1rem;
}

.poi-groups .wf-list {
  display: grid;
  gap: 1.2rem;
  grid-template-columns: 1fr 1fr 1fr;
}

.poi-groups .wf-list-item {
  height: 3.6em;
  padding: 0.4em;
  font-weight: 500;
  text-align: center;
  line-height: 1.4em;
  vertical-align: middle;

  display: flex;
  flex-direction: column;
  justify-content: center;

  &.active {
    background-color: black;
    color: white;
  }
}

.wf-search-container {
  margin: 0 !important;
  padding: 0 !important;
}

.wf-search-input-container {
  margin-bottom: 4rem;
  width: 100%;

  
}

.wf-search-input-container input {
  width: 100%;
  border: solid 0.2rem var(--th-stroke);
  border-radius: 2.7rem;
  font-size: 1.6rem;
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.18);
  padding: 1.1rem 3.5rem !important;
}

.wf-keyboard {
  padding: 1.6rem;
  gap: 0.4rem;
}

.wf-no-results {
  padding-top: 10rem;
  font-size: 4.4rem;
  font-weight: 900;
  text-transform: uppercase;
}

.keyboard-row {
  gap: 0.4rem;
  width: 100%;
  justify-content: center;
}

.keyboard-key {
  background-color: var(--th-active-content);
  width: 5rem !important;
  height: 5rem !important;
  border-radius: 2.5rem;
  line-height: 5.2rem !important;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
  font-size: 2.4rem;
  font-weight: 500;
  text-transform: uppercase;
  color: white;
}

.keyboard-key:active {
  background-color: var(--th-active);
  color: var(--th-active-content);
}
</style>
